module.exports = __webpack_public_path__ + "static/img/wks.e04e02b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wks.png
// module id = Xum7
// module chunks = 1